import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { RayCodeConstant } from './constants/RayCodeConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';
import raycodeData from '../lib/raycode.json';

const codeDefaults = { alias: [], isbuiltin: false, sortnumber: 0, s3path: '' };
const withCodeDefaults = (items) => items.map(item => ({ ...codeDefaults, ...item }));

// 현재 구현은 로컬 raycode.json 동기 dispatch (network X, idempotent, 비용 0) 이므로
// 인증 전 마운트 시점에도 안전. 추후 원격 API 호출로 변경 시 RBAC/auth gating 및
// 호출자별 마운트-fetch 패턴 (예: ServiceClaimCategory) 의 결합도/N+1 재평가 필요.
const GetAll = () => (dispatch) => {
	dispatch({ type: RayCodeConstant.LOADING });
	dispatch({ type: RayCodeConstant.GET_RAYCODELIST, items: withCodeDefaults(raycodeData) });
	dispatch({ type: RayCodeConstant.LOADED });
};

const GetAllByFilter = async (filter) => {
	const data = {
		type: 'getfilter',
		data: filter,
	};
	const ret = await axios.post(AppConfig.API_SERVER_PATH + '/code', data, JWT());
	if (ret.data.status == 'success') {
		return ret.data.data;
	} else {
		return [];
	}
};

const GetOne = (_id) => (dispatch) => {
	dispatch({ type: RayCodeConstant.LOADING });
	const item = raycodeData.find((code) => code._id === _id);
	if (item) {
		dispatch({ type: RayCodeConstant.GET_RAYCODE, item: { ...codeDefaults, ...item } });
	} else {
		dispatch(AlertAction.Error('Code not found'));
	}
	dispatch({ type: RayCodeConstant.LOADED });
};

const Delete = (_id) => async (dispatch) => {
	dispatch({ type: RayCodeConstant.LOADING });
	const data = {
		type: 'delete',
	};
	const ret = await axios.post(AppConfig.API_SERVER_PATH + '/code/' + _id, data, JWT());
	if (ret.data.status == 'success') {
		dispatch(AlertAction.Success(t('common.message.deleted')));
		dispatch({ type: RayCodeConstant.DELETE_RAYCODE, _id: _id });
	} else {
		dispatch(AlertAction.Error(ret.data));
	}
	dispatch({ type: RayCodeConstant.LOADED });
};

const Create = (info) => async (dispatch) => {
	dispatch({ type: RayCodeConstant.LOADING });
	const data = {
		type: 'create',
		data: info,
	};
	const ret = await axios.post(AppConfig.API_SERVER_PATH + '/code', data, JWT());

	console.log(ret);

	if (ret.data.status == 'success') {
		dispatch(AlertAction.Success(t('common.message.success.saved')));
		dispatch({ type: RayCodeConstant.CREATE_RAYCODE, item: ret.data.data });
	} else {
		dispatch(AlertAction.Error(ret.data));
	}
	dispatch({ type: RayCodeConstant.LOADED });
};

const AddUpdate = (info) => async (dispatch) => {
	dispatch({ type: RayCodeConstant.ADDUPDATE, item: info });
};

const Update = (_id, info) => async (dispatch) => {
	dispatch({ type: RayCodeConstant.LOADING });
	let ok = false;
	try {
		const data = {
			type: 'update',
			data: info,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/code/' + _id, data, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: RayCodeConstant.UPDATE_RAYCODE, item: ret.data.data });
			ok = true;
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.error("RayCodeAction.Update error:", error);
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: RayCodeConstant.LOADED });
	return ok;
};

export const RayCodeAction = {
	GetAll,
	GetOne,
	GetAllByFilter,
	Create,
	Update,
	Delete,
	AddUpdate
};
